<template lang="html">


  <div class="contenedor-banner-inergizate container">

    <div class="banner-inergizate column-center">
      <h3>#Inergízate</h3>
      <div class="contenedor-botones row-center">
        <router-link title="Contrata"  aria-label="Contrata"  :to="$t('enlaces.inergizate')" class="btn -degree" >Inergízate ya</router-link>
        <router-link :to="$t('enlaces.que_ofrecemos')" class="btn -skull-orange -gray-c" title="Enlace a que ofrecemos"  aria-label="Enlace a que ofrecemos" >Qué ofrecemos</router-link>
      </div>
      <img class="figura-superior" src="/static/img/figura-inergizate.gif" alt="">
      <img class="figura-inferior" src="/static/img/figura-inergizate.gif" alt="">
    </div>

  </div>


</template>

<script lang="js">
  export default  {
    name: 'banner-inergizate',
  }
</script>

<style scoped lang="scss">

  .contenedor-banner-inergizate{
    padding-top: 100px;
    padding-bottom: 100px;
  }

  [route="ofrecemos-mucho-mas"],
  [route="tarifas-luz"]{
    .contenedor-banner-inergizate{
      padding-bottom: 0;
    }
  }

  [route="tarifas-luz"],
  [route="tarifas-luz-y-gas"],
  [route="tarifa-luz-empresas"]{
   .contenedor-banner-inergizate{
    padding-top:0;
  } 
}


.banner-inergizate{
  background: url("/static/img/background-banner-inergizate.webp") center/cover no-repeat;
  padding-top: 150px;
  padding-bottom: 150px;
  position: relative;

  h3{
    font-size: 136px;
    font-weight: 800;
    color: white;
    line-height: 1em;
  }

  .contenedor-botones{
    margin-top: 50px;

    a{
      margin: 0 20px;
      min-width: 200px;
    }
  }

  .figura-superior{
    position: absolute;
    right: 0;
    top: 0;
    opacity: .4;
    max-width: 200px;
  }

  .figura-inferior{
    position: absolute;
    left: 0;
    bottom: 0;
    opacity: .4;
    transform: rotate(-180deg);
    max-width: 200px;
  }
}


[route="que-ofrecemos"] .contenedor-banner-inergizate{
  padding-bottom: 0;
}


@media screen and (max-width:900px){
  .contenedor-banner-inergizate{
    padding-top: 50px;
    padding-bottom: 50px;
  }

  .banner-inergizate{
    padding: 100px 0;
    h3{
      font-size: 90px;
    }

    .figura-superior,
    .figura-inferior{
      max-width: 140px;
    }
  }
}


@media screen and (max-width:600px){

  .banner-inergizate{
    padding: 50px 0;
    h3{
      font-size: 50px;
    }

    .contenedor-botones{
      margin-top: 25px;
     a{
      margin-right: 0;
      margin-bottom: 15px;
    }
  }
}

}

</style>



// WEBPACK FOOTER //
// src/components/parts/banner-inergizate.vue